import { render, staticRenderFns } from "./specifica.vue?vue&type=template&id=51626629&"
import script from "./specifica.vue?vue&type=script&lang=js&"
export * from "./specifica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports